import partition from 'lodash/partition';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { messages } from '../constants';
import * as D from '../deps';
import { getValidFeaturedContentIds } from '../utils';

import BackstageGrid from './BackstageGrid';
import ArtistFeaturedContentGridItem from './pages/BackstageArtist1/ArtistFeaturedContentGridItem';

const isPlaylistPandoraType = pandoraId => {
  return (
    D.Utils.SourceType.getPandoraTypeFromPandoraId(pandoraId) ===
    D.Constants.SourceTypes.PandoraTypes.PLAYLIST
  );
};

const BackstageFeaturedContent = props => {
  const { featuredContentIds, annotatePlaylists, annotatePandoraIds, validFeaturedContentIds } =
    props;

  useEffect(() => {
    const [playlists, entities] = partition(featuredContentIds.toJS(), isPlaylistPandoraType);

    if (playlists.length) {
      annotatePlaylists({ pandoraIds: playlists });
    }

    if (entities.length) {
      annotatePandoraIds(entities);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [annotatePlaylists, annotatePandoraIds]);

  if (validFeaturedContentIds.size === 0) return null;

  return (
    <D.ContentSection
      isGridList={true}
      isFeaturedContent={true}
      isFirstSection={props.isFirstSection}
      title={<FormattedMessage {...messages.spotlight} />}
    >
      <BackstageGrid>
        {validFeaturedContentIds.map(pandoraId => (
          <ArtistFeaturedContentGridItem pandoraId={pandoraId} key={pandoraId} />
        ))}
      </BackstageGrid>
    </D.ContentSection>
  );
};

BackstageFeaturedContent.propTypes = {
  validFeaturedContentIds: ImmutablePropTypes.listOf(PropTypes.string),
  featuredContentIds: ImmutablePropTypes.listOf(PropTypes.string),
  isFirstSection: PropTypes.bool,
  annotatePlaylists: PropTypes.func,
  annotatePandoraIds: PropTypes.func,
};

export function mapStateToProps(state, ownProps) {
  const { featuredContentIds } = ownProps;
  return {
    validFeaturedContentIds: getValidFeaturedContentIds(state, featuredContentIds),
  };
}

const mapDispatchToProps = {
  annotatePlaylists: D.Actions.Playlist.annotatePlaylists,
  annotatePandoraIds: D.getInDomain('catalog.actions.annotateObjectsSimple', () => {}),
};

export default connect(mapStateToProps, mapDispatchToProps)(BackstageFeaturedContent);
